
/***************************************************************************************
 * Example implementation of the "tree mode" for the ShopgateCategoryNavigation plugin
 ***************************************************************************************/

var selectedCategories = selectedCategories || [];

$(document).ready(function(){
	$('#categories-tree')
		.bind('shopgate.categoryNavigation.onBeforeInit', function(e){})
		.bind('shopgate.categoryNavigation.onInit', function(e, category){initCategoriesTree($(this), category)})
		.bind('shopgate.categoryNavigation.onCategoryUpdate', function(e, category){})
		.bind('shopgate.categoryNavigation.onInitTimeout', function(e, category){});
});

/**
 * Initializes the UI for a category navigation in tree mote
 * @param  {Object} $this      Reference to the DOM element that will contain the navigation
 * @param  {Object} category The initial datastructure for an initialized category navigation
 */
function initCategoriesTree($this, category) {
	var subcategoryNodes = {};

	// prepare the container for the new data
	$this.empty();

	if (!category || !category.category) {return false;}

	$this.append(createCategory(category));

	// if we've been waiting for a the list to be loaded, we want to see the whole list now.
	$(window).resize();

	// register an event listener for the category data update
	$this.unbind('shopgate.categoryNavigation.onCategoryUpdate').bind('shopgate.categoryNavigation.onCategoryUpdate', function(e, category){

		if (!category.category.requested_before && category.category.subcategories) {
			subcategoryNodes[category.category.number].append(createCategory(category));
		}

		updateSelectStatusForNewCategory(category);


		/*
		 // create a new category level if the new category has subcategories
		 if (category.category.subcategories) {
		 $this.append(createCategory(category));
		 }

		 // show an alert box if a category entry was clicked that contains a link that normally has to be opened in the browser
		 if (category.category.url_enabled) {
		 var message = category.category.is_show_all ? 'ShowAll URL called!' : 'Category URL called!';

		 $('.message-flat').text(message).addClass('visible');

		 window.setTimeout(function(){
		 $('.message-flat').removeClass('visible');
		 }, 1000);
		 }

		 // update the selected categories in the opened category tree
		 updateSelectStatusForNewCategory(category);
		 */
	});

	function updateSelectStatusForNewCategory(category) {
		// remove the select class from all current selected categories
		$this.find('li.selected').removeClass('selected');

		// run through the path of the newly added category to select the relevant categories
		$.each(category.category.path, function(index, entry){
			subcategoryNodes[entry].addClass('selected');
		});
	}

	function createCategory(category) {
		var $category = $('<ul>').addClass('category-level-tree nested-first current');

		if ( !category.category.is_root ) {
			var $categoryBacklink = $('<li>').addClass('nested-back').html('<a href=\"#\" class="no-sg-action">&laquo; </a>');
			var $categoryBackLinkLabel = $.i18n._('category_tree_button_back').toLowerCase();
			$categoryBacklink.find('a').append($categoryBackLinkLabel);
		}

		$category.append($categoryBacklink);

		if (Array.isArray(category.category.subcategories)) {
			// append subcategories if necessary

			$.each(category.category.subcategories, function(index, subcategory){
              // Only include the sale category on the root level
              if (!category.category.is_root && subcategory.category.is_sale) {
                  return;
              }

              $category.append(createSubcategory(subcategory));
			});
		}

		return $category;
	}

	function createSubcategory(subcategory) {

		var $subcategory = $('<li>').addClass('subcategory'),
			$subcategoryLink = $('<a>').html(subcategory.category.name).attr('href', subcategory.category.url).addClass('name needsclick');

		if (subcategory.category.has_children == true) {
			$subcategoryLink = $('<a>').html(subcategory.category.name).attr('href','#').addClass('no-sg-action name nested-parent needsclick');
		}

		//$subcategoryName.append($subcategoryLink);
		$subcategory.append($subcategoryLink);

		if (Array.isArray(subcategory.category.subcategories)) {
			$subcategory.append(createCategory(subcategory));
		}

		// trigger an event to the core that a subcategory element has been clicked
		$subcategory.click(function() {
			$this.trigger('shopgate.categoryNavigation.getCategoryByCategoryNumber', [subcategory.category.number]);
		});

		subcategoryNodes[subcategory.category.number] = $subcategory;

		return $subcategory;
	}
}



// WEBPACK FOOTER //
// ./Library/1.0/common/category-navigation-tree.js